import React, { useEffect } from 'react';
import SkillContainer from './SkillContainer.js';
import { skillCollectionsData } from '../../data';

const MySkills = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    const { comfortable, familiar, tools } = skillCollectionsData;
    return (
        <main className='uppercase min-h-screen text-center text-white'>
            <SkillContainer languages={comfortable}>comfortable With</SkillContainer>
            <SkillContainer languages={familiar}>familiar With</SkillContainer>
            <SkillContainer languages={tools}>frequently used tools</SkillContainer>
        </main>
    );
};

export default MySkills;